class ValoreGallery extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-gallery-track]');
    this.items = [...this.querySelectorAll('[data-gallery-item]')];
    this.current = this.querySelector('[data-gallery-current]');
    this.progress = this.querySelector('[data-gallery-progress]');
    this.querySelector('[data-gallery-prev]')?.addEventListener('click', () => this.move(-1));
    this.querySelector('[data-gallery-next]')?.addEventListener('click', () => this.move(1));
    this.track?.addEventListener('scroll', () => this.update(), { passive: true });
    this.update();
  }

  move(direction) {
    const item = this.items[0];
    if (!item || !this.track) return;
    const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
    this.track.scrollBy({ left: direction * (item.getBoundingClientRect().width + gap), behavior: 'smooth' });
  }

  update() {
    if (!this.track || !this.items.length) return;
    const center = this.track.scrollLeft + this.track.clientWidth / 2;
    let active = 0;
    let distance = Infinity;
    this.items.forEach((item, index) => {
      const itemCenter = item.offsetLeft + item.offsetWidth / 2;
      const nextDistance = Math.abs(itemCenter - center);
      if (nextDistance < distance) {
        distance = nextDistance;
        active = index;
      }
    });
    if (this.current) this.current.textContent = String(active + 1).padStart(2, '0');
    if (this.progress) this.progress.style.width = `${((active + 1) / this.items.length) * 100}%`;
  }
}

if (!customElements.get('valore-gallery')) customElements.define('valore-gallery', ValoreGallery);

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('a[href^="#valore-size-guide-"]');
  if (!trigger) return;

  const target = document.querySelector(trigger.getAttribute('href'));
  if (!(target instanceof HTMLDetailsElement)) return;

  event.preventDefault();
  target.open = true;
  target.scrollIntoView({ behavior: 'smooth', block: 'start' });
});
